export const twoDaysInTheFuture = (): number => new Date().setDate(new Date().getDate() + 2);

export const isExpirationDateValid = (expiresAt?: number): boolean =>
  !!expiresAt && expiresAt > Date.now() && expiresAt <= twoDaysInTheFuture();
